export const partnersLogos = [
  { name: "Ifood", image: "/images/partners/ifood.webp" },
  { name: "Madeira Madeira", image: "/images/partners/madeiramadeira.webp" },
  { name: "Picpay", image: "/images/partners/picpay.webp" },
  { name: "Grupo Boticário", image: "/images/partners/grupoboticario.webp" },
  { name: "James", image: "/images/partners/james.webp" },
  { name: "Méliuz", image: "/images/partners/meliuz.webp" },
  { name: "Mirum", image: "/images/partners/mirum.webp" },
  { name: "Creditas", image: "/images/partners/creditas.webp" },
  { name: "99 Hunters", image: "/images/partners/99hunters.webp" },
  { name: "Acras", image: "/images/partners/acras.webp" },
  { name: "Anthor", image: "/images/partners/anthor.webp" },
  { name: "Banco Bari", image: "/images/partners/bancobari.webp" },
  { name: "Apinteractive", image: "/images/partners/apinteractive.webp" },
  { name: "Apsis", image: "/images/partners/apsis.webp" },
  { name: "Ateliware", image: "/images/partners/ateliware.webp" },
  { name: "Autoforce", image: "/images/partners/autoforce.webp" },
  { name: "Bcredi", image: "/images/partners/bcredi.webp" },
  { name: "BDR", image: "/images/partners/bdr.webp" },
  { name: "Bemol digital", image: "/images/partners/bemoldigital.webp" },
  { name: "Bycoders", image: "/images/partners/bycoders.webp" },
  { name: "Cargon", image: "/images/partners/cargon.webp" },
  { name: "Cipa", image: "/images/partners/cipa.webp" },
  { name: "Clube do valor", image: "/images/partners/clubedovalor.webp" },
  { name: "Conectadoc", image: "/images/partners/conectadoc.webp" },
  { name: "Consuti", image: "/images/partners/consuti.webp" },
  { name: "Esales", image: "/images/partners/esales.webp" },
  { name: "Cplug", image: "/images/partners/cplug.webp" },
  { name: "Grupo Digi", image: "/images/partners/grupodigi.webp" },
  { name: "Datatype", image: "/images/partners/datatype.webp" },
  { name: "Db1 group", image: "/images/partners/db1group.webp" },
  { name: "Dclick", image: "/images/partners/dclick.webp" },
  { name: "Econet", image: "/images/partners/econet.webp" },
  { name: "Elo verde", image: "/images/partners/eloverde.webp" },
  { name: "Asaplog", image: "/images/partners/asaplog.webp" },
  { name: "Xpand", image: "/images/partners/xpand.webp" },
  { name: "Esparta", image: "/images/partners/esparta.webp" },
  { name: "Espresso labs", image: "/images/partners/espressolabs.webp" },
  { name: "Evlos", image: "/images/partners/evlos.webp" },
  { name: "Exati", image: "/images/partners/exati.webp" },
  { name: "Helpie", image: "/images/partners/helpie.webp" },
  { name: "Fanbase", image: "/images/partners/fanbase.webp" },
  { name: "Fiberx", image: "/images/partners/fiberx.webp" },
  { name: "Gatec", image: "/images/partners/gatec.webp" },
  { name: "Geek Hunter", image: "/images/partners/geekhunter.webp" },
  { name: "Girotech", image: "/images/partners/girotech.webp" },
  { name: "Grupo Mayer", image: "/images/partners/grupomayer.webp" },
  { name: "Paraná Banco", image: "/images/partners/paranabanco.webp" },
  { name: "GTI Solutions", image: "/images/partners/gtiitsolutions.webp" },
  { name: "HC Consulting", image: "/images/partners/hcconsulting.webp" },
  { name: "Coopers", image: "/images/partners/coopers.webp" },
  { name: "Humanaz", image: "/images/partners/humanaz.webp" },
  { name: "Iguatemi", image: "/images/partners/iguatemi.webp" },
  {
    name: "Instituto Eldorado",
    image: "/images/partners/institutoeldorado.webp",
  },
  { name: "IOASYS", image: "/images/partners/ioasys.webp" },
  { name: "ItFlex", image: "/images/partners/itflex.webp" },
  { name: "Zumer", image: "/images/partners/zumer.webp" },
  { name: "Block Force", image: "/images/partners/blockforce.webp" },
  { name: "Juno", image: "/images/partners/juno.webp" },
  { name: "KMM", image: "/images/partners/kmm.webp" },
  { name: "Leankeep", image: "/images/partners/leankeep.webp" },
  { name: "Chaves na mão", image: "/images/partners/chavesnamao.webp" },
  { name: "Letras", image: "/images/partners/letras.webp" },
  { name: "Ucondo", image: "/images/partners/ucondo.webp" },
  { name: "Locus", image: "/images/partners/locus.webp" },
  { name: "Luby", image: "/images/partners/luby.webp" },
  { name: "Startyouup", image: "/images/partners/startyouup.webp" },
  { name: "Vitto", image: "/images/partners/vitto.webp" },
  { name: "Mapes", image: "/images/partners/mapes.webp" },
  { name: "MCFO", image: "/images/partners/mcfo.webp" },
  { name: "Cits", image: "/images/partners/cits.webp" },
  { name: "Mentores", image: "/images/partners/mentores.webp" },
  {
    name: "Mulheres no comando",
    image: "/images/partners/mulheresnocomando.webp",
  },
  { name: "Grupo Barigui", image: "/images/partners/grupobarigui.webp" },
  { name: "Nava", image: "/images/partners/Nava.webp" },
  { name: "Omni chat", image: "/images/partners/omnichat.webp" },
  { name: "Onli-seguro", image: "/images/partners/onli-seguro.webp" },
  { name: "Origina.io", image: "/images/partners/origina.io.webp" },
  { name: "Páprica", image: "/images/partners/páprica.webp" },
  { name: "Provi", image: "/images/partners/provi.webp" },
  { name: "Monditech", image: "/images/partners/monditech.webp" },
  { name: "People Plan", image: "/images/partners/peopleplan.webp" },
  { name: "Pieta", image: "/images/partners/pieta.webp" },
  { name: "Plastika", image: "/images/partners/plastika.webp" },
  { name: "Porto a porto", image: "/images/partners/portoaporto.webp" },
  { name: "Qulture rocks", image: "/images/partners/qulturerocks.webp" },
  { name: "RCZ", image: "/images/partners/rcz.webp" },
  { name: "Remessa online", image: "/images/partners/remessaonline.webp" },
  { name: "Revelo", image: "/images/partners/revelo.webp" },
  { name: "Gestran", image: "/images/partners/gestran.webp" },
  { name: "Roit bank", image: "/images/partners/roit.webp" },
  { name: "Sat", image: "/images/partners/sat.webp" },
  { name: "SB credito", image: "/images/partners/sbcredito.webp" },
  { name: "Seidor", image: "/images/partners/seidor.webp" },
  { name: "Seox", image: "/images/partners/seox.webp" },
  { name: "Siteware", image: "/images/partners/siteware.webp" },
  { name: "Smarthint", image: "/images/partners/smarthint.webp" },
  { name: "Sociawave", image: "/images/partners/sociawave.webp" },
  { name: "Soft Focus", image: "/images/partners/softfocus.webp" },
  { name: "Soft Plan", image: "/images/partners/softplan.webp" },
  { name: "Pixlog", image: "/images/partners/pixlog.webp" },
  { name: "Spin", image: "/images/partners/spin.webp" },
  { name: "Stefanini group", image: "/images/partners/stefaninigroup.webp" },
  { name: "Tewone", image: "/images/partners/tewone.webp" },
  { name: "Trakto", image: "/images/partners/trakto.webp" },
  { name: "Mannesoft", image: "/images/partners/mannesoft.webp" },
  { name: "Vhsys", image: "/images/partners/vhsys.webp" },
  { name: "Vulpi", image: "/images/partners/vulpi.webp" },
  { name: "Weexpass", image: "/images/partners/weexpass.webp" },
  { name: "Xgen", image: "/images/partners/xgen.webp" },
  { name: "Zallpy", image: "/images/partners/zallpy.webp" },
  { name: "Iteris", image: "/images/partners/iteris.webp" },
  { name: "Grupo Services", image: "/images/partners/gruposervices.webp" },
];
